var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-modal',{attrs:{"title":"修改密码","width":"400px","height":"290px"},model:{value:(_vm.formVisible),callback:function ($$v) {_vm.formVisible=$$v},expression:"formVisible"}},[_c('ResetPwd',{on:{"closeParent":_vm.closeParent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }